// src/components/FlipCard/FlipCard.jsx
import React, { useState } from 'react';
import './FlipCard.css';

const FlipCard = ({ flippable = true, front, back, footer }) => {
  const [flipped, setFlipped] = useState(false);

  const handleClick = () => {
    if (flippable) setFlipped((f) => !f);
  };

  return (
    <div
      className={`flip-card${!flippable ? ' no-flip' : ''}${flipped ? ' flipped' : ''}`}
      onClick={handleClick}
    >
      <div className="flip-card-inner">
        <div className="flip-card-front">
          <div className="flip-card-front-content">
            {front}
          </div>
          {footer}
        </div>
        <div className="flip-card-back">
          <div className="flip-card-back-content">
            {back}
          </div>
          {footer}
        </div>
      </div>
    </div>
  );
};

export default FlipCard;
